export interface Buyer {
  name: string
  city: string
  country: string
  flag: string
}

export const buyers: Buyer[] = [
  { name: 'Ashley R.', city: 'Phoenix, AZ', country: 'United States', flag: '🇺🇸' },
  { name: 'Charlotte H.', city: 'Leeds', country: 'United Kingdom', flag: '🇬🇧' },
  { name: 'Mélanie G.', city: 'Montréal, QC', country: 'Canada', flag: '🇨🇦' },
  { name: 'Chloe T.', city: 'Melbourne, VIC', country: 'Australia', flag: '🇦🇺' },
  { name: 'Brittany M.', city: 'Atlanta, GA', country: 'United States', flag: '🇺🇸' },
  { name: 'Olivia P.', city: 'Bristol', country: 'United Kingdom', flag: '🇬🇧' },
  { name: 'Jessica L.', city: 'Calgary, AB', country: 'Canada', flag: '🇨🇦' },
  { name: 'Hannah W.', city: 'Adelaide, SA', country: 'Australia', flag: '🇦🇺' },
  { name: 'Marcus J.', city: 'Chicago, IL', country: 'United States', flag: '🇺🇸' },
  { name: 'Grace O.', city: 'Glasgow', country: 'United Kingdom', flag: '🇬🇧' },
  { name: 'Megan S.', city: 'Vancouver, BC', country: 'Canada', flag: '🇨🇦' },
  { name: 'Sophie K.', city: 'Sydney, NSW', country: 'Australia', flag: '🇦🇺' },
]
